import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=19f3172a&"
import script from "./global-search.vue?vue&type=script&lang=js&"
export * from "./global-search.vue?vue&type=script&lang=js&"
import style0 from "./global-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f3172a')) {
      api.createRecord('19f3172a', component.options)
    } else {
      api.reload('19f3172a', component.options)
    }
    module.hot.accept("./global-search.vue?vue&type=template&id=19f3172a&", function () {
      api.rerender('19f3172a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/search/global-search.vue"
export default component.exports